"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlternativeOnActivityResult = exports.AlternativeOnBackPressed = exports.AlternativeSourceType = exports.AlternativeFullscreen = exports.AlternativeLayoutType = exports.AlternativeStorageType = exports.AlternativeNavigation = exports.AlternativeLogicType = exports.AlternativeNetworkTool = void 0;
var AlternativeNetworkTool;
(function (AlternativeNetworkTool) {
    AlternativeNetworkTool["RETROFIT"] = "Retrofit";
    AlternativeNetworkTool["VOLLEY"] = "Volley";
    AlternativeNetworkTool["HTTP_URL"] = "HTTPUrlConnection";
})(AlternativeNetworkTool = exports.AlternativeNetworkTool || (exports.AlternativeNetworkTool = {}));
var AlternativeLogicType;
(function (AlternativeLogicType) {
    AlternativeLogicType["CALLBACKS"] = "Callback";
    AlternativeLogicType["RX"] = "RX";
    AlternativeLogicType["COROUTINES"] = "Coroutines";
})(AlternativeLogicType = exports.AlternativeLogicType || (exports.AlternativeLogicType = {}));
var AlternativeNavigation;
(function (AlternativeNavigation) {
    AlternativeNavigation["ACTIVITY"] = "Activity";
    AlternativeNavigation["FRAGMENT_FM"] = "Fragment";
    AlternativeNavigation["FRAGMENT_NAV_HOST"] = "Fragment (NavHost)";
})(AlternativeNavigation = exports.AlternativeNavigation || (exports.AlternativeNavigation = {}));
var AlternativeStorageType;
(function (AlternativeStorageType) {
    AlternativeStorageType["FILE"] = "File";
    AlternativeStorageType["ROOM"] = "Room";
    AlternativeStorageType["ENCRYPTED_PREFS"] = "Encrypted Preferences";
    AlternativeStorageType["SHARED_PREFERENCES"] = "Shared Preferences";
    AlternativeStorageType["CONTENT_PROVIDER"] = "Content Provider";
})(AlternativeStorageType = exports.AlternativeStorageType || (exports.AlternativeStorageType = {}));
var AlternativeLayoutType;
(function (AlternativeLayoutType) {
    AlternativeLayoutType["DATA_BINDING"] = "DataBinding";
    AlternativeLayoutType["BY_ID"] = "findViewById";
    AlternativeLayoutType["PROGRAMATICALLY"] = "Create in code";
})(AlternativeLayoutType = exports.AlternativeLayoutType || (exports.AlternativeLayoutType = {}));
var AlternativeFullscreen;
(function (AlternativeFullscreen) {
    AlternativeFullscreen["INSETS"] = "Insets";
    AlternativeFullscreen["FLAGS"] = "Flags";
    AlternativeFullscreen["IMMERSIVE"] = "Immersive";
})(AlternativeFullscreen = exports.AlternativeFullscreen || (exports.AlternativeFullscreen = {}));
var AlternativeSourceType;
(function (AlternativeSourceType) {
    AlternativeSourceType["FIREBASE_REALTIME_DATABASE"] = "Firebase Realtime DB";
    AlternativeSourceType["GET_RETROFIT"] = "From link via Retrofit";
    AlternativeSourceType["GET_VOLLEY"] = "From link via Volley";
    AlternativeSourceType["GET_HTTP_URL"] = "From link via HTTPUrlConnection";
    AlternativeSourceType["DIRECT"] = "Directly from link";
    // WITHIN_WEBVIEW = "Within webview",
})(AlternativeSourceType = exports.AlternativeSourceType || (exports.AlternativeSourceType = {}));
// backpress
// activity result
// fulscreen
var AlternativeOnBackPressed;
(function (AlternativeOnBackPressed) {
    AlternativeOnBackPressed["OLD"] = "Old";
    AlternativeOnBackPressed["NEW"] = "New";
})(AlternativeOnBackPressed = exports.AlternativeOnBackPressed || (exports.AlternativeOnBackPressed = {}));
var AlternativeOnActivityResult;
(function (AlternativeOnActivityResult) {
    AlternativeOnActivityResult["OVERRIDE"] = "Override";
    AlternativeOnActivityResult["CALLBACK"] = "Callback";
})(AlternativeOnActivityResult = exports.AlternativeOnActivityResult || (exports.AlternativeOnActivityResult = {}));
